<app-spinner *ngIf="isLoadingConversation" placement="full-page" size="34px"></app-spinner>

<app-page-wrapper *ngIf="!isLoadingConversation" [scrollable]="true">

  <ng-container *ngIf="agentMode === 'agent'">
    <div *ngIf="appState.agent.currentConversation().length === 0" class="agent-get-started-wrapper">
      <app-primary-header fontSize="48px" mobileFontSize="42px">Where are you going?</app-primary-header>
      <app-primary-text [lineHeight]="1.45">Tell me when and where you want to go or the details of your reservation with open
        seats.</app-primary-text>
    </div>

    <button
      *ngIf="appState.agent.currentConversation().length === 0 && !hasClickedTrustedContactsNotice"
      type="button"
      class="trusted-contacts-notice"
      (click)="openTrustedContactsNotice()"
      aria-label="Invite Trusted Contacts"
    >
      <span class="trusted-contacts-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" focusable="false">
          <path d="M12 12.4c2.35 0 4.25-1.9 4.25-4.25S14.35 3.9 12 3.9 7.75 5.8 7.75 8.15s1.9 4.25 4.25 4.25Z"></path>
          <path d="M5.7 19.2c.78-2.8 3.15-4.45 6.3-4.45s5.52 1.65 6.3 4.45c.15.55-.29 1.05-.86 1.05H6.56c-.57 0-1.01-.5-.86-1.05Z"></path>
        </svg>
      </span>
      Invite Trusted Contacts
    </button>

    <div class="agent-conversation-wrapper" *ngIf="appState.agent.currentConversation().length > 0" [ngClass]="{'keyboard-focused': appState.device.isKeyboardFocused()}">
      <div class="agent-conversation-tools-wrapper">
        <app-agent-conversation-shadow></app-agent-conversation-shadow>
      </div>
      <div class="agent-conversation-thread-wrapper">
        <app-agent-conversation-minimal></app-agent-conversation-minimal>
      </div>
    </div>

   

    <div class="agent-conversation-inputs-wrapper" [style.visibility]="appState.agent.hideInput() ? 'hidden' : 'visible'"
      [ngClass]="{'hidden-input' : appState.agent.isHandlingQuery()}">
      <app-agent-conversation-inputs (handleCreateNewConvo)="handleCreateNewConversation()"
       ></app-agent-conversation-inputs>
    </div>
  </ng-container>

  <ng-container *ngIf="agentMode === 'results'">
    <app-agent-results></app-agent-results>
  </ng-container>


</app-page-wrapper>
